const modalBackups = {
  title: 'Editar Backup',
  placeholder: 'Buscar',
  name: 'Nombre del archivo',
  size: 'Talla',
  fileType: 'Tipo de archivo',
  createdAt: 'Creado en',
  createdBy: 'Creado por',
  ingestedBy: 'Consumido por',
  ingestedAt: 'Consumido en',
  ingested: 'Consumido',
};

export default modalBackups;
